import apiFetch from '../apiFetch'

export default function ({idVerraco,idOperarioColecta,fechaExtraccion,volumen}) {
  return apiFetch({endPoint: `Foso/imprimirMiniEtiqueta?idVerraco=${idVerraco}&idOperarioColecta=${idOperarioColecta}&fechaExtraccion=${fechaExtraccion}&volumen=${volumen}`, method: 'GET', body: null, token: null})
}